import React from "react"
// import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitInformation.module.scss"
// import styled from 'styled-components'

const RecruitInformation = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "i" },
    { "id": 1, "text": "n" },
    { "id": 2, "text": "f" },
    { "id": 3, "text": "o" },
    { "id": 4, "text": "r" },
    { "id": 5, "text": "m" },
    { "id": 6, "text": "a" },
    { "id": 7, "text": "t" },
    { "id": 8, "text": "i" },
    { "id": 9, "text": "o" },
    { "id": 10, "text": "n" },
  ];

  const Items1 = [
    { "heading": "募集職種", "content": "営業：山口県内外ルートセールス" },
    { "heading": "採用人数", "content": "若干名" },
    { "heading": "勤務予定地", "content": "山口県長門市、山口県山口市、広島県廿日市市、島根県松江市" },
  ];
  const Items2 = [
    { "heading": "募集職種", "content": "生産：種鶏飼育管理" },
    { "heading": "採用人数", "content": "若干名" },
    { "heading": "勤務予定地", "content": "山口県長門市、山口県美祢市" },
  ];
  const Items3 = [
    { "heading": "募集職種", "content": "製造：鶏肉加工・加熱加工品製造" },
    { "heading": "採用人数", "content": "若干名" },
    { "heading": "勤務予定地", "content": "山口県長門市" },
  ];
  const Items4 = [
    { "heading": "給与", "content": "職務経歴・業務能力を考慮し、当組合規程により優遇します。" },
    { "heading": "昇給", "content": "年1回（※当該年度の業績による）" },
    { "heading": "賞与", "content": "年2回（※当該年度の業績による）" },
    { "heading": "勤務時間", "content": "8:00～17:00（実労8時間）" },
    { "heading": "休日休暇", "content": "年間休日110日（事業場カレンダーに準ずる）" },
    { "heading": "福利厚生", "content": "健康・厚生年金・労災・雇用保険完備、退職金制度等" },
    { "heading": "採用実績校	", "content": "山口大学、山口県立大学、山口農業大学校、広島大学、広島工業大学、福山大学、島根大学、島根県立大学、長崎県立大学　他" },
    { "heading": "教育制度", "content": "新入社員研修、管理職研修、食品衛生管理研修、外部機関研修等" },
    { "heading": "応募方法", "content": "下記の応募フォームに必要事項をご記入のうえ送信いただくか、以下担当者までお電話・メールにてお問い合わせください。詳細についてお知らせいたします。" },
  ];

  return (
    <div className={styles.RecruitInformation}>
      <div className={styles.RecruitInformation__inner}>
        <TitleAnimation data={title1} className={`titleRubikCenter`} />
        <h2 className={`subH2`}>募集要項</h2>
        <div className={styles.RecruitInformation__content}>
          <ul>
            <li>
              <div className={styles.RecruitInformation__title}><span>営業職</span></div>
              <dl className={styles.RecruitInformation__table} >
                {Items1.map((Item, i) => (
                  <div className={styles.div} key={i} index={i}>
                    <dt className={styles.dt}><span>{Item.heading}</span></dt>
                    <dd className={styles.dd}>{Item.content}</dd>
                  </div>
                ))}
              </dl>
            </li>
            <li>
              <div className={styles.RecruitInformation__title}><span>生産職</span></div>
              <dl className={styles.RecruitInformation__table} >
                {Items2.map((Item, i) => (
                  <div className={styles.div} key={i} index={i}>
                    <dt className={styles.dt}><span>{Item.heading}</span></dt>
                    <dd className={styles.dd}>{Item.content}</dd>
                  </div>
                ))}
              </dl>
            </li>
            <li>
              <div className={styles.RecruitInformation__title}><span>製造職</span></div>
              <dl className={styles.RecruitInformation__table} >
                {Items3.map((Item, i) => (
                  <div className={styles.div} key={i} index={i}>
                    <dt className={styles.dt}><span>{Item.heading}</span></dt>
                    <dd className={styles.dd}>{Item.content}</dd>
                  </div>
                ))}
              </dl>
            </li>
            <li>
              <div className={styles.RecruitInformation__title}><span>雇用条件</span></div>
              <dl className={styles.RecruitInformation__table} >
                {Items4.map((Item, i) => (
                  <div className={styles.div} key={i} index={i}>
                    <dt className={styles.dt}><span>{Item.heading}</span></dt>
                    <dd className={styles.dd}>{Item.content}</dd>
                  </div>
                ))}
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
export default RecruitInformation
